/* eslint-disable no-empty-pattern */
import Store from "@/services/store";
import Router from "@/services/router";
import axios from "@/services/vue-axios";
import schedulerModule from "@/modules/scheduler/module";
import adaptersOut from "@/services/data-adapter/outgoing/user";

export default {
  init({ dispatch }) {
    console.info("User module initialized.");
    dispatch("initModule", schedulerModule);
  },
  initModule({ dispatch }, module) {
    Store.registerModule(module.name, module.store);
    Router.addRoutes(module.routes);
    dispatch(module.name + "/init", null, { root: true });
  },

  update({}, user) {
    return new Promise((resolve, reject) => {
      adaptersOut.user(user).then(res => {
        const user = res;
        axios
          .put(
            "/users/" + user.id,
            { user },
            { withCredentials: true, credentials: "include", mode: "cors" }
          )
          .then(response => submitSuccessful(response))
          .catch(error => submitFailed(error));
      });

      var submitSuccessful = res => {
        return resolve(res);
      };

      var submitFailed = error => {
        if (process.env.NODE_ENV !== "production") {
          console.log(error.response);
        }
        return reject(this.$t("app.actions.failed.update"));
      };
    });
  }
};
